module.exports = __webpack_public_path__ + "static/mw9-3d223d3bd06bee5548335b289e3002ae.jpg";